import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { selectDetectorreinstatementSectionData } from './DetectorReinstatement.data';
import { StyleDropdown } from '../AsFoundTestWorkshop/AsFoundTestWorkshop.styled';

const useStyles = formName => makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const DetectorreinstatementSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly } = props;
    const classes = useStyles(formName)();
    const formDropdownInput = (field) => field.isDropDown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                labelWidth={field.labelWidth}
                readOnly={isFormReadOnly || field.readOnly}
                direction={field.direction}
                marginLeft={field.marginLeft}
                marginTop={field.marginTop}
                borderTop={field.borderTop}
                inputTextAlign={field.inputTextAlign}
                marginBottom={field.marginBottom}
                borderBottom={field.borderBottom}
                height={field.height}
                isDisabled={field.isDisabled}
                fontSize={field.fontSize}
                arrowMarginTop={field.arrowMarginTop}
                paddingPlaceholder={field.paddingPlaceholder}
            />
        </StyleDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                isCalculated={field.isCalculated}
                isCalculatedNew={field.isCalculatedNew}
                isDisabled={field.isDisabled}
                readOnly={field.readOnly || isFormReadOnly}
                handleChange={changeHandler}
                direction={field.direction}
                textAlign={field.textAlign}
                type={field.type}
                padding={field.padding}
                width={field.width}
                labelWidth={field.labelWidth}
                marginLeft={field.marginLeft}
                maxLength={field.maxLength}
                marginRight={field.marginRight}
                fontSize={field.fontSize}
                marginBottom={field.marginBottom}
                marginTop={field.marginTop}
                borderRight={field.borderRight}
                height={field.height}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                isLabelNew={field.isLabelNew}
                inputMarginRight={field.inputMarginRight}
                isLabelBold={field.isLabelBold}
                fontWeight={field.fontWeight}
            />
        );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectDetectorreinstatementSectionData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key} style={{ textAlign: 'end' }}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            fontSize={field.fontSize}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : formDropdownInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ TagSelectionMOScreen, Forms }) => ({
    selectedTag: Forms.selectedTag,
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DetectorreinstatementSection);

DetectorreinstatementSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
};
